import {ApplicationState, defaultGaasApplicationDataMapper} from '@gaas/gaas-react-component-library';
import {AppConfig} from '../../custom-typings/typings';
import {RegistrationForm} from '../types/GaasAppState';

export const convertToGaasRegistrationForm = (data: ApplicationState, appConfig: AppConfig): RegistrationForm => {
    try {
        return defaultGaasApplicationDataMapper(data, appConfig);
    } catch (err) {
        console.error('Error mapping submission: ', err);
        throw err;
    }
}
